module.exports = __webpack_public_path__ + "img/udn_logo.29ac896e.svg";